export const mockUsersArray = [
    {
        id:"0",
        first_name:"Bank",
        last_name:"Admin",
        email:"test@gmail.com",
        phone:"(303)123-4567",
        address:{
            "address":"123 test lane",
            "address_two":"",
            "city":"longmont",
            "state":"CO",
            "zip":"80501"
        },
        username:"bank_ee",
        passwrd:"pass",
        rle:"bank_admin",
        bank_branch_association:""
    },
    {
        id:"1",
        first_name:"Inspector",
        last_name:"Admin",
        email:"test@gmail.com",
        phone:"(303)123-4567",
        address:{
            "address":"123 test lane",
            "address_two":"",
            "city":"longmont",
            "state":"CO",
            "zip":"80501"
        },
        username:"inspector_admin",
        passwrd:"pass",
        rle:"inspector_admin",
        bank_branch_association:""
    },
    {
        id:"2",
        first_name:"Inspector",
        last_name:"Inspector",
        email:"test@gmail.com",
        phone:"(303)123-4567",
        address:{
            "address":"123 test lane",
            "address_two":"",
            "city":"longmont",
            "state":"CO",
            "zip":"80501"
        },
        username:"inspector_ee",
        passwrd:"pass",
        rle:"inspector_inspector",
        bank_branch_association:""
    },
    {
        id:"3",
        first_name:"Admin",
        last_name:"last",
        email:"test@gmail.com",
        phone:"(303)123-4567",
        address:{
            "address":"123 test lane",
            "address_two":"",
            "city":"longmont",
            "state":"CO",
            "zip":"80501"
        },
        username:"admin_ee",
        passwrd:"pass",
        rle:"admin_admin",
        bank_branch_association:""
    }


];


export const findUser = (username,password) =>{
    console.log(username)
    console.log(password)
    let foundUser = mockUsersArray.filter((user) => 
        user.username === username && user.passwrd === password
    );
    if (foundUser.length === 1){
        return foundUser[0];
    }else{
        return null;
    }
    
    // const result = words.filter((word) => word.length > 6);
}


